import {Option} from "../interfaces/inputs/OptionInterfaces";

export const ORIGIN_OPTIONS: Option<string>[] = [
  { value: "FR", label: "resource_origin_fr"},
  { value: "EU", label: "resource_origin_eu"},
  { value: "NOT_EU", label: "resource_origin_not_eu"}
]
